import IEventService from '../../../../eventService/IEventService';
import { getServices } from '../../../../../infra/startup';
import {
  EventServiceCallBackType,
  ListenerHandlerType,
  OnboardingAgentEvents
} from '../../../../eventService/types';
import { internalLogger } from '../../../../../interface/v1/clientOsLogger';

class EventManager {
  private _eventService: IEventService;

  constructor() {
    const services = getServices();
    this._eventService = services?.eventService;
  }

  public subscribeToEvent(
    eventName: string,
    callback: EventServiceCallBackType
  ): Promise<ListenerHandlerType> {
    return this._eventService.subscribe(eventName, callback);
  }

  public sendOnboardingFailedToLaunchEvent(): void {
    this._eventService.publish(
      OnboardingAgentEvents.onboardingAgentFailedToLaunch,
      undefined
    );
  }

  public sendWebOnboardingStartedEvent(appSessionId: string): void {
    internalLogger?.log?.('onboarding-agent-event: WebOnboardingStarted', {
      appSessionId
    });
    this._eventService.publish(
      this._eventService.eventNames.webOnboardingStarted,
      { appSessionId }
    );
  }

  public sendWebOnboardingStageStartedEvent(
    appSessionId: string,
    serviceId?: string
  ): void {
    internalLogger?.log?.('onboarding-agent-event: WebOnboardingStageStarted', {
      appSessionId,
      serviceId
    });
    this._eventService.publish(
      this._eventService.eventNames.webOnboardingStageStarted,
      {
        appSessionId,
        serviceId
      }
    );
  }

  public sendOnboardingStageFinishedEvent(
    appSessionId: string,
    serviceId: string,
    resultData: {
      result: 'success' | 'failed' | 'cancelled';
      output?: Record<string, any>;
      xCorrelationId: string;
    },
    xCorrelationId: string
  ): void {
    const payload = {
      appSessionId,
      serviceId,
      result: {
        result: resultData?.result,
        xCorrelationId: resultData?.xCorrelationId || xCorrelationId
      }
    };
    internalLogger?.log?.(
      'onboarding-agent-event: WebOnboardingStageFinished',
      payload
    );
    this._eventService.publish(
      this._eventService.eventNames.webOnboardingStageFinished,
      payload
    );
  }
}
export default EventManager;
